/*****HEADER******/

/***COMPONENT***/
export default function Header(data) {
  //DOM
  return (
    <header id="header">
      <nav role="navigation">
        <div>
          {/*Site Logo*/}
          <a target="_blank" href="https://www.unimes.fr/fr/index.html">
            <img
              fetchpriority="high"
              src="/img/Logo.webp"
              className="logo"
              alt="Logo de l'université de Nîmes"
            />
          </a>
        </div>
        <div className=" titleWrap">
          <h1 className="numTitle">UNANÎMES</h1>
          <h2 className="numTitle numTitle2">Université Numérique Avancée</h2>
        </div>

        {/*Menu*/}
        <div className="rightNav">
          {/*MENU*/}
          <ul className="menu">
            {/*1 - Accueil/Projet*/}
            <li className="list">
              <a href="/accueil">Projet</a>
            </li>
            {/*2 - Réalisations*/}
            <li className="list subMenu2Wrap">
              <p> Réalisations</p>
              <ul className="subMenu">
                <li className="subList">
                  <a href="/enseignement-numerique">Enseignement numérique</a>
                </li>
                <li className="subList">
                  <a href="/campus-augmente">campus augmenté</a>
                </li>
                <li className="subList">
                  <a href="/simplification-administrative">
                    simplification administrative
                  </a>
                </li>
              </ul>
            </li>
            {/*3 - Partenaires*/}
            <li className="list">
              <a href="/partenaires">Partenaires</a>
            </li>

            {/*4 - Contact*/}
            {/*<li className="list">
                          <a href="/contact">Contact</a>
                        </li>*/}
          </ul>
        </div>
        {/*Contact*/}

        <a
          className="faLink"
          href="mailto:snap@unimes.fr"
          target="_blank"
          title="Lien vers l'adresse mail du chef de projet UNANÎMES"
        >
          <i className="fa fa-envelope" aria-hidden="true"></i>
        </a>
        {/*page linkedin UNANIMES*/}
        <a
          className="faLink"
          href="https://www.linkedin.com/showcase/universit%C3%A9-num%C3%A9rique-avanc%C3%A9e-%C3%A0-n%C3%AEmes-demoes"
          target="_blank"
          title="Lien vers la page linkedin du projet UNANÎMES"
        >
          <i className="fa fa-linkedin" aria-hidden="true"></i>
        </a>
        {/*En savoir plus -- site unimes*/}

        <a
          className="faLink"
          href="https://www.unimes.fr/fr/universite/projets-d-etablissement/projet-demoes.html"
          target="_blank"
          title="Lien vers la page Unimes du projet UNANÎMES"
        >
          <i className="fa fa-plus-circle" aria-hidden="true"></i>
        </a>
        {/*
        <a
          className="faLink"
          href="/newsletter"
          target="_blank"
          title="Lien vers la page Unimes du projet UNANÎMES"
        >
          <i className="fa fa-plus-circle" aria-hidden="true"></i>
        </a>*/}
      </nav>
    </header>
  );
}
